import { getSeoUrl } from "../common/commonFunctions";
import { BhpMarketTypes, SeoUrlDetailsType } from "../pages/BussinessHomePage";

const getBhpShareMessage = (
  isMarket: boolean,
  marketDomain: string,
  domainName: string,
  name: string,
  marketType: BhpMarketTypes,
  seoDetails: SeoUrlDetailsType
): string => {
  let url =
    isMarket && marketType === "USER"
      ? `https://vypzee.com/business/${domainName}`
      : isMarket && marketType === "VYPZEE"
      ? "https://vypzee.com"
      : getSeoUrl(seoDetails);
  const message = `${
    isMarket ? "Market" : "Business"
  } ${name} is online. Visit at: ${url}`;
  const messageUser = `Visit and Save my Business Card. ${url}`;
  return isMarket && marketType === "USER" ? messageUser : message;
};
const isMobileNumber = (phone: string) => {
  if (phone[0] === "0") {
    if (phone[1] === "9" || phone[1] === "8" || phone[1] === "7") {
      return true;
    }
  } else if (phone[0] === "9" || phone[0] === "8" || phone[0] === "7")
    return true;
  return false;
};

export { getBhpShareMessage, isMobileNumber };
